// document.addEventListener('DOMContentLoaded', function() {
// 	const searchButtons = document.querySelectorAll('.header .search-button');

// 	console.log( searchButtons );
// 	searchButtons.forEach(function(searchButton) {
// 		searchButton.addEventListener('click', function() {
// 			const href = searchButton.getAttribute('data-href');
// 			let queryString = FWP.buildQueryString();

// 			console.log( queryString );
// 			// window.location.href = href + '?' + queryString;
// 		});
// 	});
// });